import {
  ConversationOrderSummary,
  ConversationVendorOrderSummary,
  type IConversationVendorOrderSummaryGroup,
} from '../../../../components/ConversationOrderSummary'
import { useCartContext } from '../../../../providers/CartProvider'
import {
  type ConversationCartComponent,
  type ConversationCartItem,
  type ConversationCartVendor,
} from '../../../../value-objects/ConversationTurnItem'

export interface IConversationCartProps {
  cart: ConversationCartComponent
}

const toGroups = (
  vendors: ConversationCartVendor[],
  items: ConversationCartItem[]
): IConversationVendorOrderSummaryGroup[] => {
  const groups = vendors
    .map(({ vendor, items: vendorItems, subtotal }) => ({
      vendor,
      subtotal,
      items: items.filter((item) =>
        vendorItems.some((vendorItem) => vendorItem.id === item.id)
      ),
    }))
    .filter((group) => group.items.length > 0)
  const groupedCount = groups.reduce(
    (count, group) => count + group.items.length,
    0
  )
  return groupedCount === items.length ? groups : [{ items }]
}

export const ConversationCart = ({ cart }: IConversationCartProps) => {
  const {
    decorate,
    isContinuing,
    setQuantity,
    remove,
    continueToOrderRequest,
  } = useCartContext()

  const { items, total, currency, disabled } = decorate(cart)

  if (cart.vendors?.length) {
    return (
      <ConversationVendorOrderSummary
        groups={toGroups(cart.vendors, items)}
        total={total}
        currency={currency}
        disabled={disabled}
        totalLabel={cart.totalLabel}
        continueAction={cart.continueAction}
        disclaimer={cart.disclaimer}
        isContinueLoading={isContinuing}
        onQuantityChange={setQuantity}
        onRemove={remove}
        onContinue={continueToOrderRequest}
      />
    )
  }

  return (
    <ConversationOrderSummary
      items={items}
      total={total ?? 0}
      currency={currency}
      disabled={disabled}
      vendor={cart.vendor}
      totalLabel={cart.totalLabel}
      continueAction={cart.continueAction}
      disclaimer={cart.disclaimer}
      isContinueLoading={isContinuing}
      onQuantityChange={setQuantity}
      onRemove={remove}
      onContinue={continueToOrderRequest}
    />
  )
}
